<script>
    import slider from "shared/Components/slider.vue";
    import signup from "shared/components/forms/signup.vue";
    import errorList from "shared/Components/errorList.vue";
    import error from "shared/Components/error.vue";
    import f9button from "inputs/f9button.vue";
    import forgotPassword from "forms/forgotPassword.vue";
    import f9input from 'inputs/f9input.vue';
    import f9field from 'inputs/f9field.vue';
    import { getMember } from 'shared/member';
    import { login, attachToLoginEvent } from 'shared/login';
    import { getIbeHost, getCDNHost, postJson } from "shared/Utilities/fetchUtilities";
    import { attach } from "shared/eventBus";
    import { continueToPassengerEditFromLoginOrDDSignup } from "shared/Utilities/flightSelectUtilites";

    export default {
        props: {
            "reloadOnLogin": Boolean,
            "showSignupSuccess": {
                type: Boolean,
                default: true
            },
            "showSignup": {
                type: Boolean,
                default: true
            },
            "showPasswordReset": {
                type: Boolean,
                default: true
            },
            "hide": Function,
            "hasGrayBackground": {
                type: Boolean,
                default: true
            },
            "validationScope": {
                type: String,
                default: "login-fields"
            },
            "inPathDD": {
                type: Boolean,
                default: false
            }
        },
        components: {
            slider,
            signup,
            forgotPassword,
            error,
            errorList,
            f9button,
            f9input,
            f9field
        },
        data() {
            return {
                email: "",
                password: "",
                hidePasswordReset: false,
                forgotModalOpacity: 0,
                forgotSliderOpen: false,
                error: false,
                signUpSliderOpacity: 0,
                changed: false,
                host: "",
                cdnHost: "//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net",
                submitting: false,
                member: {},
                flightSelectForm: HTMLElement,
                ref: { inWPPath: false }
            }
        },
        mounted() {
            window.inPathDDForLoginSlider = this.ref;

            this.hidePasswordReset = !this.showPasswordReset;

            attachToLoginEvent(() => {
                this.signUpSliderOpacity = .5;
            });

            if (!this.inPathDD) {
                window.flightSelectSignupSlider = () => {
                    this.signUpSliderOpacity = .5;
                    this.signUpSlider()
                };
            }

            attach("openFrontierMilesSlider", () => this.openFrontierMilesSlider());

            this.$nextTick(() => this.host = getIbeHost());
            this.$nextTick(() => this.cdnHost = getCDNHost());
        },
        methods: {
            login() {
                this.$refs.submitButton.focus();
                this.error = false;
                this.submitting = true;
                if (this.ref.inWPPath && wpromote.adult == 1)
                    this.inPathDD = true;
                this.validate(this.validationScope).then(result => {
                    if (result) {
                        login(this.email, this.password, this.host, !this.inPathDD)
                            .then(obj => {
                                if (obj.reset) {
                                    //TODO Reset password slider
                                    window.location = this.host + "/Member/ResetPassword";
                                    return;
                                } else if (obj.valid) {
                                    this.$emit("login-success");
                                    if (this.inPathDD) {
                                        if (!this.continueToPassengerEdit()) {
                                            postJson(this.host + "/F9Loyalty/AddFakeDDSignup").then(json => {
                                                window.location.reload();
                                            });
                                        }
                                        else {
                                            this.flightSelectForm = document.getElementById("flight-select-form");
                                            if (this.flightSelectForm) {

                                              this.flightSelectForm.submit();
                                            }
                                        }
                                    }
                                    else if (this.reloadOnLogin) {
                                        window.location.reload();
                                    } else {
                                        this.changed = false;
                                        this.submitting = false;
                                        getMember(false, null, this.host).then(res => {
                                            this.member = res;
                                        });
                                    }
                                } else {
                                    this.hidePasswordReset = false;
                                    this.error = true;
                                    this.submitting = false;
                                }
                            })
                            .catch(x => {
                                this.error = true
                                this.submitting = false;
                            });
                    }
                    this.submitting = false;
                });
            },
            resetPasswordSlider() {
                this.hidePasswordReset = false;
                this.$refs.forgotSlider.show();
            },
            signUpSlider(opacity) {
                if (typeof opacity === "number") {
                    this.signUpSliderOpacity = opacity;
                }
                this.$refs.signupSlider.show();
            },
            passwordIsReset() {
                if (this.hide) {
                    this.hide();
                    this.forgotModalOpacity = .5;
                }
            },
            getHost() {
                return getIbeHost();
            },
            doNothing() {
            },
            onChange(e) {
                this.changed = true;
                this.$emit('change', e);
            },
            openFrontierMilesSlider() {
                this.$refs.signupSlider.show();
            },
            continueToPassengerEdit() {
                return continueToPassengerEditFromLoginOrDDSignup();
            }
        }
    }
</script>

<template>
    <div class="login-container" :class="{ 'has-gray-background': hasGrayBackground }" @keydown.enter="login" @input.stop.prevent="doNothing" @change.stop.prevent="doNothing" @keyup.stop.prevent="doNothing">
        <h2 v-if="hasGrayBackground">LOGIN TO <i>FRONTIER MILES<small>sm</small></i></h2>
        <error v-if="error" class="login-error">
            Error: Your login information is incorrect. Please check your details and try again or <a href='#0' @click="resetPasswordSlider">reset your password</a> now.
        </error>
        <error-list v-if="error" class="login-error" :messages="errors.items"></error-list>
        <f9field>
            <span slot="label" class="slider-label">Email Address or <i>FRONTIER Miles</i><small>sm</small> #</span>
            <f9input :saved="!changed" v-model="email" type="text" autocomplete="off" name="email" v-validate="'required'" @change="changed = true" :data-vv-scope="validationScope"></f9input>
        </f9field>
        <f9field>
            <span slot="label" class="slider-label">Password</span>
            <f9input :saved="!changed" v-model="password" type="password" autocomplete="off" name="password" v-validate="'required'" @change="onChange" :data-vv-scope="validationScope"></f9input>
        </f9field>
        <f9button :disabled="!changed" ref="submitButton" name="submit" @click="login" :loading="submitting">LOG IN</f9button>
        <div class="l">
            <a class="login-forgot link" role="button" tabindex="0" @click="resetPasswordSlider">Forgot Password?</a>
        </div>
        <div class="hr" v-if="hasGrayBackground"></div>
        <div class="login-footer" v-if="showSignup">
            <div class="login-footer-bold">
                NOT A MEMBER?
                <f9button nostyle class="link join-now" @click="signUpSlider(0)">SIGN UP</f9button>
                TODAY!
            </div>
            <div class="login-footer-small" v-if="!hasGrayBackground">
                Earn miles towards your next trip by joining our Frequent Flyer Program today!
            </div>
        </div>
        <slider ref="forgotSlider" title="PASSWORD RESET" v-model="forgotSliderOpen" :modal-opacity="forgotModalOpacity" v-if="!hidePasswordReset">
            <forgot-password :email="email" :slider-open="forgotSliderOpen" @reset="passwordIsReset"></forgot-password>
        </slider>
        <slider ref="signupSlider" title="SIGN UP" :modal-opacity="signUpSliderOpacity" v-if="showSignup">
            <signup :show-success="showSignupSuccess" :reload-on-login="reloadOnLogin"></signup>
        </slider>
    </div>
</template>

<style lang="less" scoped>
@import "~less-variables";
    
    .login-container {
        
        input {
            padding-top: 8px;
        }

        &.has-gray-background {
            margin: -16px -16px 14px -16px;
            background-image: linear-gradient(@ibe-background--bluegray, @ibe-background--light-bluegray);
            height: 100%;

            input {
                font-family: @frontierFontFamily;

                &:focus {
                    border-color: @ibe-background--blue;
                }
            }

            h2 {
                color: @white;
                font-size: 20px;
                padding-top: 39px;
                padding-bottom: 19px;
                width: 310px;
                line-height: initial;
                margin: 0 auto;

                img {
                    width: 34px;
                    height: 26px;
                    position: relative;
                    vertical-align: initial;
                    bottom: -12px;
                    left: -1px;

                    @media @IE11 {
                        vertical-align: auto;
                    }
                }

                small {
                    font-weight: 400;
                    font-size: 4px;
                    position: relative;
                    top: -15px;
                    left: 2px;
                }
            }

            .login-error, .error-container {
                background-color: #cfd3d5;
                margin-top: 0;
                padding: 10px 10px;
                margin-bottom: 19px;

                .error {
                    margin: 0;
                    padding: 5px 0;
                    
                    .error-img img {
                        width: initial;
                        height: initial;
                    }
                }
            }

            .slider-field, @{deep} .button, .l {
                display: block;
                width: 300px;
                margin: 0 auto;
            }

            .l .link {
                font-size: 11px;
                color: @white;
                margin-top: 14px;
                line-height: initial;

                &:hover {
                    color: @white;
                }
            }

            @{deep} .button {
                height: 62px;
                line-height: 62px;
                padding: 0;
            }

            .slider-field {
                margin-bottom: 17px;

                .slider-label {
                    font-size: 11px;
                    color: @white;
                    line-height: initial;
                }
            }

            .hr {
                border-bottom: 1px solid @white;
                margin: 24px 58px;
            }

            .login-footer {
                margin: 0 auto;
                width: 400px;
                text-align: center;
                color: @white;

                .login-footer-bold @{deep} .join-now {
                    font-size: 18px;
                    text-decoration: underline;

                    &:hover {
                        color: @white;
                    }
                }
            }
        }

        .slider-field {
            margin-bottom: 15px;

            .slider-label {
                font-size: 12px;
    
                small {
                    vertical-align: super;
                    font-size: 6px;
                    padding-left: 1px;
                }
            }
        }

        .login-footer {
            margin-top: 15%;

            .login-footer-bold {
                font-weight: 700;
                font-size: 18px;
                
                .join-now {
                    font-size: 16px;
                }
            }


            .login-footer-small {
                text-transform: none;
            }
        }

        .login-forgot {
            font-size: 12px;
        }

        .l {
            width: 300px;
            text-align: right;

            .link {
                color: @frontier-green;
                display: inline-block;
                margin-top: 12px;

                &:hover, :active {
                    color: @ibe-text-blue;
                }
            }
        }
        
        .login-error {
            margin-bottom: 20px;
        }

        @{deep} .button {
            margin-top: 0;
        }
    }

    @media @tablet {
        .login-container {
            margin-top: 6px;

            &.has-gray-background {
                margin: -9px;
                padding: 10px 13px;
                height: ~"calc(100% + 18px)";

                h2 {
                    font-size: 18px;
                    padding-top: 6px;
                    width: 300px;
                    padding-bottom: 13px;

                    img {
                        width: 24px;
                        height: 20px;
                        position: relative;
                        bottom: -9px;
                        left: 1px;
                        margin-right: 2px;
                    }

                    small {
                        top: -11px;
                        left: 1px;
                    }
                }

                .login-error, .error-container {
                    padding: 5px 12px;
                    margin: 0 -13px;
                    margin-bottom: 19px;

                    @{deep} .error-img {
                        align-self: flex-start;
                        margin-top: 2px;
                    }

                    @{deep} .error-message {
                        font-size: 11px;
                    }
                }

                .slider-field {
                    margin-bottom: 16px;
                }

                @{deep} .button {
                    height: 55px;
                    line-height: 55px;
                }

                .l {
                    width: 100%;
                }

                .hr {
                    margin: 19px 0 21px 0;
                }

                .login-footer {
                    width: 100%;

                    .login-footer-bold {
                        font-size: 16px;

                        .join-now {
                            font-size: 16px;
                        }
                    }
                }
            }


            .l {
                width: 100%;

                .link {
                    display: block;
                    font-size: 11px;
                }
            }

            .slider-field {
                .slider-label {
                    font-size: 11px;
                    padding-bottom: 6px;
                }
            }

            input {
                margin-bottom: 14px;
            }
        }
    }
</style>